import api from 'common/api';
import {
  SearchUserMasterRequest,
  DetailUserMasterRequest,
  UpdateUserMasterRequest,
  DeleteUserMasterRequest,
  GetDivisionListRequest,
} from 'api-types/src/types/user-mast';

export const getUserMastListApi = (params: SearchUserMasterRequest) => api.get('/user-mast/list', params);

export const getMenuAuthorityApi = () => api.get('/user-mast/get-menu-authority');

export const DOWNLOAD_EXCEL_USER_MAST = '/user-mast/list';

export const getUserGroupApi = () => api.get('/user-mast/get-user-group');

export const getDivisionListApi = (params: GetDivisionListRequest) => api.get('/user-mast/get-division-list', params);

export const initializationPasswordApi = () => api.get('/user-mast/default-pwd');

export const addUserMastApi = (params: UpdateUserMasterRequest) => api.post('/user-mast/add-user', params);

export const getDetailUserMastApi = (params: DetailUserMasterRequest) => api.get('/user-mast/detail', params);

export const deleteUserMastApi = (params: DeleteUserMasterRequest) => api.put('/user-mast/delete-user', params);

export const updateUserMastApi = (params: UpdateUserMasterRequest) => api.put('/user-mast/update-user', params);
